<template>
  <div class="animated fadeIn">
    <b-container fluid class="pt-3 pr-3 pb-0 pl-3">
      <b-row>
        <b-col cols="12" class="">
          <!-- Cancellations -->
          <b-card class="border-0">
            <div class="card-text pb-0">
              <div class="d-flex flex-row justify-content-start">
                <div class="text-dark mr-3"><span class="headericon"></span></div>
                <div class="h4 font-weight-bold text-dark">Finansiering</div>
              </div>
            </div>
          </b-card>
          <b-card class="pt-0 pr-2 pb-0 border-0">
            <div class="card-text">
              <div class="h5 open-sans line-height-golden py-4">
                Her kan du lave en låneberegning til dine potentielle kunder og sende den videre til Resurs Bank.
              </div>
            </div>
          </b-card>
          <b-card class="pt-0 pb-0 border-0">
            <div class="card-text">
              <finanscalc></finanscalc>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import finanscalc from './NewFinansCalc'
export default {
  components: {
    finanscalc
  }
}
</script>
<style scoped>
.table thead th,
.table th,
.table td {
  border-bottom: 0;
  border-top: 0;
}
</style>


// WEBPACK FOOTER //
// Finansiering.vue?75652c84